module.exports = __webpack_public_path__ + "static/media/small-soldiers1.2cc0fd18.gif";